import { BREAKPOINTS } from '~scripts/core/breakpoints';
import { getScrollbarWidth } from '~scripts/core/helpers';

export default function Navigation(breakpoint = BREAKPOINTS.xlMin) {
  const navigation = document.getElementById('navigation');

  if (navigation) {
    const root = document.documentElement;
    const body = document.body;

    const navigationModalDisableAt = window.matchMedia(`(min-width: ${breakpoint})`);

    const navigationList = document.getElementById('navigationList');
    const navigationToggle = document.getElementById('navigationToggle');

    const modalHelpers = {
      open: function () {
        navigation.classList.add('navigation--modal');
        navigationList.classList.add('navigation__list--opening');

        navigationList.addEventListener(
          'animationend',
          () => {
            const scrollbarWidth = getScrollbarWidth();

            root.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
            body.classList.add('no-scroll');

            if (scrollbarWidth) {
              body.style.paddingRight = `${scrollbarWidth}px`;
            }

            navigationList.classList.remove('navigation__list--opening');
          },
          {
            once: true,
          }
        );
      },
      close: function () {
        navigationToggle.blur();
        body.classList.remove('no-scroll');

        if (body.style.paddingRight) {
          body.style.removeProperty('padding-right');
        }

        root.style.removeProperty('--scrollbar-width');
        navigationList.classList.add('navigation__list--closing');

        navigationList.addEventListener(
          'animationend',
          () => {
            navigation.classList.remove('navigation--modal');
            navigationList.classList.remove('navigation__list--closing');

            navigationDropdown.forEach((dropdown) => {
              dropdown.dataset.dropdownControl = 'collapsed';
            });
          },
          {
            once: true,
          }
        );
      },
    };

    // Toggling dropdowns
    const navigationDropdown = navigation.querySelectorAll('[data-dropdown-control]');

    navigationDropdown.forEach((dropdown) => {
      dropdown.addEventListener('click', (e) => {
        const target = e.target;

        if (target.tagName.toLowerCase() === 'a' && window.matchMedia(`(max-width: ${BREAKPOINTS.xlMin}`).matches) {
          e.preventDefault();
        }

        if (target.dataset.dropdownControl === 'collapsed') {
          target.dataset.dropdownControl = 'expanded';
        } else {
          target.dataset.dropdownControl = 'collapsed';
        }
      });
    });

    // Toggling modal
    navigationToggle.addEventListener('click', (e) => {
      e.preventDefault();

      if (navigation.classList.contains('navigation--modal')) {
        modalHelpers.close();
      } else {
        modalHelpers.open();
      }
    });

    // Closing modal on `ESC`
    window.addEventListener('keyup', (e) => {
      e.preventDefault();

      if (e.code === 'Escape' && navigation.classList.contains('navigation--modal')) {
        modalHelpers.close();
      }
    });

    // Closing modal on `click`
    const navigationModalClose = document.querySelectorAll('.js-navigation-modal-close');

    navigationModalClose.forEach((item) => {
      item.addEventListener('click', () => {
        if (navigation.classList.contains('navigation--modal')) {
          modalHelpers.close();
        }
      });
    });

    // On media change
    navigationModalDisableAt.addEventListener('change', () => {
      if (navigationModalDisableAt.matches) {
        if (navigation.classList.contains('navigation--modal')) {
          modalHelpers.close();
        }
      }
    });
  }
}
